const AcademicBackground = ({ academics }) => {
  // const academics = [
  //     {
  //         logo: "/images/act.png",
  //         institution: "ACT Test",
  //         date: "March 2022",
  //         score: "Score: 32",
  //         certificate: "/images/certificate.png"
  //     },
  //     {
  //         logo: "/images/houston.png",
  //         institution: "University of Houston",
  //         date: "March 2010 - 2015",
  //         score: "GPA: 4.00",
  //         certificate: "/images/certificate.png"
  //     },
  //     {
  //         logo: "/images/houstonSchool.png",
  //         institution: "Houston Independent School",
  //         date: "March 2007 - 2010",
  //         score: "GPA: 4.75",
  //         certificate: "/images/certificate.png"
  //     }
  // ];

  return (
    <div className="-mt-16 space-y-[18px] pt-16" id="academic background">
      <p className="text-[22px] font-normal leading-normal tracking-[-0.44px] text-[#012E33]">
        Academic Background
      </p>

      <div className="space-y-2">
        {Object.keys(academics).map((item, index) => {
          if (!academics[item]) return null;
          return (
            <div
              key={index}
              className="flex items-center justify-between rounded-[16px] bg-[#EFF7F7] p-4"
              style={{ minHeight: '100px' }}
            >
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-full">
                  <img
                    src={item !== 'highSchool' ? '/uni/houston.png' : '/uni/houstonSchool.png'}
                    alt="Institution logo"
                    className="h-full w-full object-contain"
                  />
                </div>

                <div className="flex flex-col">
                  <h3 className="tracking[-0.32px] text-[16px] font-normal leading-normal text-[#012E33]">
                    {item === 'highSchool' ? 'High School' : 'Undergraduate'}{' '}
                  </h3>
                  <p className="tracking[-0.32px] text-[16px] font-normal leading-normal text-[#678285]">
                    {academics[item]}
                  </p>
                  <p className="tracking[-0.32px] text-[16px] font-normal leading-normal text-[#678285]">
                    66
                  </p>
                </div>
              </div>

              <div className="h-16 w-24 flex-shrink-0">
                <img
                  src={'/images/certificate.png'}
                  alt="Certificate"
                  className="h-full w-full object-contain opacity-80"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AcademicBackground;
